import React from 'react';

function Trees() {
  return (
    <g>
      <path
        d="M149.39 197.17s-.05-2.75 2.26-2.88c2.72-.15 2.68 2.6 2.68 3.49 0 0 .92.77.92 1.95s-.25 1.7-.25 1.7.66.62.81 1.7c.15 1.08-.61 1.69-.76 1.84 0 0 .32 1.32-.56 2.2-.56.57-1.39 1.08-2.31.98 0 0-.37.56-1.9.41-.71-.07-1.9-.67-2.06-2.11-.75-.36-1.23-1.18-1.13-2.36 0 0-.77-.26-.77-2.06 0-1.44 1.25-1.61 1.25-1.61s-.58-1.31.32-2.48c.67-.86 1.52-.79 1.52-.79l-.02.02Z"
        fill="#87AC57"
      />
      <path d="m151.54 198.3-.65 16h1.09l-.44-16Z" fill="#835D4C" />
      <path
        d="m149.58 202.35 1.96.9v.97l-1.96-1.87Zm3.34-1.11-1.38.64v.68l1.38-1.32Zm1 2.29-2.38 1.11v1.18l2.38-2.29Z"
        fill="#835D4C"
      />
      <path
        d="M160.081 203.07s-.05-2.75 2.26-2.88c2.72-.15 2.68 2.6 2.68 3.49 0 0 .92.77.92 1.95s-.25 1.7-.25 1.7.66.62.81 1.7c.15 1.08-.61 1.69-.76 1.84 0 0 .32 1.32-.56 2.2-.56.57-1.39 1.08-2.31.98 0 0-.37.56-1.9.41-.71-.07-1.9-.67-2.06-2.11-.75-.36-1.23-1.18-1.13-2.36 0 0-.77-.26-.77-2.06 0-1.44 1.25-1.61 1.25-1.61s-.58-1.31.32-2.48c.67-.86 1.52-.79 1.52-.79l-.02.02Z"
        fill="#87AC57"
      />
      <path d="m162.23 204.2-.65 16h1.09l-.44-16Z" fill="#835D4C" />
      <path
        d="m160.271 208.25 1.959.91v.97l-1.959-1.88Zm3.339-1.11-1.38.64v.69l1.38-1.33Zm1 2.3-2.38 1.1v1.18l2.38-2.28Z"
        fill="#835D4C"
      />
      <path
        d="M169.93 208.3s-.05-2.75 2.26-2.88c2.72-.15 2.68 2.6 2.68 3.49 0 0 .92.77.92 1.95s-.25 1.7-.25 1.7.66.62.81 1.7c.15 1.08-.61 1.69-.76 1.84 0 0 .32 1.32-.56 2.2-.56.57-1.39 1.08-2.31.98 0 0-.37.56-1.9.41-.71-.07-1.9-.67-2.06-2.11-.75-.36-1.23-1.18-1.13-2.36 0 0-.77-.26-.77-2.06 0-1.44 1.25-1.61 1.25-1.61s-.58-1.31.32-2.48c.67-.86 1.52-.79 1.52-.79l-.02.02Z"
        fill="#87AC57"
      />
      <path d="m172.07 209.43-.64 16h1.09l-.45-16Z" fill="#835D4C" />
      <path
        d="m170.12 213.48 1.95.91v.96l-1.95-1.87Zm3.33-1.11-1.38.64v.68l1.38-1.32Zm1.01 2.3-2.39 1.1v1.18l2.39-2.28Z"
        fill="#835D4C"
      />
      <path
        d="M213.31 239.99s-.06-3.54 2.91-3.7c3.5-.2 3.44 3.34 3.44 4.49 0 0 1.18.99 1.18 2.51 0 1.52-.32 2.19-.32 2.19s.84.8 1.04 2.19c.2 1.39-.78 2.17-.98 2.37 0 0 .41 1.69-.73 2.83-.72.73-1.78 1.39-2.97 1.26 0 0-.48.72-2.44.53-.92-.09-2.44-.86-2.64-2.71-.96-.46-1.59-1.52-1.45-3.04 0 0-.99-.33-.99-2.64 0-1.86 1.6-2.07 1.6-2.07s-.75-1.69.41-3.18c.86-1.11 1.95-1.02 1.95-1.02l-.01-.01Z"
        fill="#87AC57"
      />
      <path d="m216.06 241.44-.83 20.57h1.41l-.58-20.57Z" fill="#835D4C" />
      <path
        d="m213.551 246.65 2.51 1.16v1.24l-2.51-2.4Zm4.29-1.43-1.78.82v.88l1.78-1.7Zm1.29 2.95-3.07 1.42v1.52l3.07-2.94Z"
        fill="#835D4C"
      />
      <path
        d="M230.501 252.98s-.06-3.54 2.91-3.7c3.5-.2 3.44 3.34 3.44 4.49 0 0 1.18.99 1.18 2.51 0 1.52-.32 2.19-.32 2.19s.84.8 1.04 2.19c.2 1.39-.78 2.17-.98 2.37 0 0 .41 1.69-.73 2.83-.72.73-1.78 1.39-2.97 1.26 0 0-.48.72-2.44.53-.92-.09-2.44-.86-2.64-2.71-.96-.46-1.59-1.52-1.45-3.04 0 0-.99-.33-.99-2.64 0-1.86 1.6-2.07 1.6-2.07s-.75-1.69.41-3.18c.86-1.11 1.95-1.02 1.95-1.02l-.01-.01Z"
        fill="#87AC57"
      />
      <path d="m233.261 254.43-.83 20.57h1.4l-.57-20.57Z" fill="#835D4C" />
      <path
        d="m230.751 259.64 2.51 1.16v1.25l-2.51-2.41Zm4.29-1.43-1.78.82v.88l1.78-1.7Zm1.29 2.95-3.07 1.42v1.52l3.07-2.94Z"
        fill="#835D4C"
      />
      <path
        d="M251.681 269.64s-.07-3.76 3.09-3.94c3.72-.21 3.66 3.55 3.66 4.78 0 0 1.26 1.06 1.26 2.67 0 1.61-.35 2.33-.35 2.33s.9.85 1.11 2.33c.21 1.48-.83 2.31-1.04 2.52 0 0 .43 1.8-.77 3.01-.77.78-1.9 1.48-3.16 1.33 0 0-.51.76-2.6.56-.97-.09-2.6-.91-2.81-2.88-1.03-.49-1.69-1.62-1.55-3.23 0 0-1.05-.35-1.05-2.81 0-1.97 1.7-2.2 1.7-2.2s-.8-1.8.43-3.39c.92-1.18 2.08-1.09 2.08-1.09v.01Z"
        fill="#87AC57"
      />
      <path d="m254.62 271.18-.89 21.88h1.5l-.61-21.88Z" fill="#835D4C" />
      <path
        d="m251.94 276.72 2.68 1.24v1.32l-2.68-2.56Zm4.57-1.52-1.89.88v.93l1.89-1.81Zm1.37 3.14-3.26 1.51v1.62l3.26-3.13Z"
        fill="#835D4C"
      />
      <path
        d="M280.9 288.75s-.07-3.72 3.06-3.9c3.68-.21 3.62 3.51 3.62 4.72 0 0 1.24 1.04 1.24 2.64s-.34 2.3-.34 2.3.89.84 1.09 2.3c.2 1.46-.82 2.28-1.03 2.49 0 0 .43 1.78-.76 2.98-.76.77-1.88 1.46-3.13 1.32 0 0-.51.75-2.57.56-.96-.09-2.57-.9-2.78-2.85-1.01-.48-1.67-1.6-1.53-3.2 0 0-1.04-.35-1.04-2.78 0-1.95 1.68-2.17 1.68-2.17s-.79-1.78.43-3.35c.91-1.17 2.05-1.07 2.05-1.07l.01.01Z"
        fill="#87AC57"
      />
      <path d="m283.8 290.28-.87 21.63h1.48l-.61-21.63Z" fill="#835D4C" />
      <path
        d="m281.16 295.76 2.64 1.22v1.3l-2.64-2.52Zm4.51-1.51-1.87.87v.92l1.87-1.79Zm1.36 3.11-3.23 1.49v1.59l3.23-3.08Z"
        fill="#835D4C"
      />
    </g>
  );
}

export default Trees;
